interface AddIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function AddIcon({ color = 'currentColor', ...svgProps }: AddIconProps) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M6 2.625V9.375M9.375 6H2.625"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
